import { render, staticRenderFns } from "./AlertBlock.vue?vue&type=template&id=6c55b22b&"
import script from "./AlertBlock.vue?vue&type=script&lang=js&"
export * from "./AlertBlock.vue?vue&type=script&lang=js&"
import style0 from "./AlertBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports